var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2424 935.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-12,.cls-13,.cls-22{fill:#42565e;}.cls-2{fill:#7891ba;}.cls-3{fill:#4a73af;}.cls-4{fill:#f74f8b;}.cls-5{fill:#cad0d8;}.cls-6{fill:#89b5e5;}.cls-7{fill:#891253;}.cls-22,.cls-7{opacity:0.5;}.cls-8{fill:#8fb0e2;}.cls-10,.cls-24,.cls-8{opacity:0.4;}.cls-24,.cls-9{fill:#7cc2ed;}.cls-11{fill:#fff;}.cls-12,.cls-15{opacity:0.15;}.cls-13,.cls-14{opacity:0.2;}.cls-15{fill:#050505;}.cls-16{fill:#86a5d1;}.cls-17{fill:#f4a864;}.cls-18{fill:#ea8028;}.cls-19{fill:#566366;}.cls-20{fill:#4b5b5e;opacity:0.6;}.cls-21{fill:#f9637c;}.cls-23{fill:#82cbf1;}.cls-25{opacity:0.6;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 720") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1999.28,856.22H1872a5,5,0,0,1,0-10h118.72l92.34-593.77a5,5,0,0,1,9.88,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2274.61,42V32.16a16,16,0,1,1,32.1,0V42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2306.71,32.16V42a16,16,0,1,0-32.1,0V32.16a16,16,0,1,1,32.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2133.6,39.16h0c0-16.82,19.71-30.45,44-30.45h31.69c24.32,0,44,13.63,44,30.45h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2253.35,39.16h-1.8c-5.38-12.62-22.26-21.82-42.24-21.82h-31.68c-20,0-36.85,9.2-42.24,21.82h-1.8c0-16.83,19.72-30.46,44-30.46h31.68C2233.64,8.7,2253.35,22.33,2253.35,39.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2253.35,40.45a5,5,0,0,1-5-5c0-13.8-17.87-25.45-39-25.45h-31.69c-21.16,0-39,11.66-39,25.45a5,5,0,0,1-10,0c0-19.55,22-35.45,49-35.45h31.69c27,0,49,15.9,49,35.45A5,5,0,0,1,2253.35,40.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2306.71,45.8a5,5,0,0,1-5-5V30.93a11,11,0,0,0-22.1,0V40.8a5,5,0,1,1-10,0V30.93a21,21,0,0,1,42.1,0V40.8A5,5,0,0,1,2306.71,45.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2220.71,38.33v-8h0a6.79,6.79,0,0,0-6.79-6.79H2173a6.79,6.79,0,0,0-6.79,6.79h0v9.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2166.24,41.33a3,3,0,0,1-3-3V29.07a9.8,9.8,0,0,1,9.79-9.79h40.89a9.8,9.8,0,0,1,9.79,9.79v8a3,3,0,0,1-6,0v-8a3.79,3.79,0,0,0-3.79-3.79H2173a3.79,3.79,0,0,0-3.79,3.79v9.26A3,3,0,0,1,2166.24,41.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2258.86,
    y: 443.96,
    width: 35.22,
    height: 400.1,
    rx: 8,
    ry: 8,
    transform: "translate(-88.49 580.58) rotate(-14.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2248.69,454.31,2343.15,826c1.13,4.45-5.59,10-15,12.4l-98.55-387.78a30.17,30.17,0,0,1,12.67-.71C2245.7,450.55,2248.13,452.08,2248.69,454.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2306.42,848.26l-100.9-397,43.38-11,100.9,397Zm-89.31-390.12,96.2,378.53,24.89-6.33L2242,451.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2222.87,
    y: 516.4,
    width: 58.7,
    height: 43.25,
    rx: 3.45,
    ry: 3.45,
    transform: "translate(-63.13 571.34) rotate(-14.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2277.21,517.19l6.91,27.2a7.61,7.61,0,0,1-5.49,9.23l-21.48,5.46-10.65-41.92L2268,511.7A7.61,7.61,0,0,1,2277.21,517.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2231.93,570.91a9.49,9.49,0,0,1-9.17-7.14l-8.34-32.8a9.47,9.47,0,0,1,6.85-11.51L2269,507.31a9.49,9.49,0,0,1,11.52,6.85l8.34,32.8a9.47,9.47,0,0,1-6.85,11.51l-47.77,12.14A9.53,9.53,0,0,1,2231.93,570.91Zm39.39-54.4-47.69,12.19,8.38,32.72,47.63-12.17Zm8.38,32.72,1.17,4.62-1.17-4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2280.86,536.31a4.77,4.77,0,0,1-1.17-9.39l30.89-7.85a4.77,4.77,0,1,1,2.35,9.24L2282,536.16A4.78,4.78,0,0,1,2280.86,536.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2305.58,548.29a2,2,0,0,1-2-1.54l-10-39.43a2,2,0,0,1,4-1l10,39.43a2,2,0,0,1-2,2.55Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2264.79,
    y: 681.32,
    width: 58.7,
    height: 43.25,
    rx: 3.45,
    ry: 3.45,
    transform: "translate(-102.46 586.74) rotate(-14.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2319.13,682.12l6.91,27.2a7.61,7.61,0,0,1-5.49,9.23L2299.07,724l-10.65-41.92,21.48-5.46A7.61,7.61,0,0,1,2319.13,682.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2273.86,735.83a9.49,9.49,0,0,1-9.18-7.14l-8.34-32.8a9.47,9.47,0,0,1,6.85-11.51L2311,672.24a9.47,9.47,0,0,1,11.52,6.85l8.34,32.8A9.47,9.47,0,0,1,2324,723.4l-47.77,12.14A9.46,9.46,0,0,1,2273.86,735.83Zm39.37-54.4-47.69,12.19,8.38,32.72,47.63-12.17Zm8.38,32.72,1.17,4.62-1.17-4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2322.77,701.24a4.77,4.77,0,0,1-1.17-9.39l30.89-7.85a4.77,4.77,0,1,1,2.35,9.24L2324,701.09A4.78,4.78,0,0,1,2322.77,701.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2347.5,713.21a2,2,0,0,1-2-1.54l-10-39.43a2,2,0,0,1,4-1l10,39.43a2,2,0,0,1-2,2.55Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2305,
    y: 828.57,
    width: 47.33,
    height: 37.19,
    rx: 8.45,
    ry: 8.45,
    transform: "translate(-136.92 599.69) rotate(-14.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2318.63,873.3A16.31,16.31,0,0,1,2302.85,861l-3.49-13.73a16.28,16.28,0,0,1,11.77-19.78l23.56-6a16.28,16.28,0,0,1,19.79,11.77L2358,847a16.28,16.28,0,0,1-11.77,19.79l-23.56,6A16.26,16.26,0,0,1,2318.63,873.3Zm20.08-42.74a6.78,6.78,0,0,0-1.67.21l-23.56,6a6.74,6.74,0,0,0-4.87,8.19l3.49,13.73a6.75,6.75,0,0,0,8.19,4.87l23.56-6a6.74,6.74,0,0,0,4.87-8.19l-3.49-13.73a6.74,6.74,0,0,0-6.52-5.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2101.51,
    y: 442.72,
    width: 35.22,
    height: 400.1,
    rx: 8,
    ry: 8,
    transform: "translate(260.5 -561.11) rotate(16.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2190.91,465,2084.83,833.51c-1.27,4.41-9.87,5.81-19.22,3.12l110.68-384.49a30.17,30.17,0,0,1,11.3,5.78C2190.22,460.24,2191.55,462.79,2190.91,465Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2084.88,846.59l-43-12.38,113.32-393.66,43,12.38Zm-31.21-18.91,24.68,7.1,108-375.32-24.68-7.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2122.34,
    y: 517.42,
    width: 58.7,
    height: 43.25,
    rx: 3.45,
    ry: 3.45,
    transform: "matrix(0.96, 0.28, -0.28, 0.96, 233.07, -574.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2183.78,533.68l-7.76,27a7.61,7.61,0,0,1-9.4,5.2l-21.3-6.13,12-41.57,21.3,6.13A7.61,7.61,0,0,1,2183.78,533.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2169.75,572.13a9.51,9.51,0,0,1-2.63-.37l-47.37-13.64a9.47,9.47,0,0,1-6.48-11.72l9.36-32.52a9.48,9.48,0,0,1,11.72-6.48L2181.72,521a9.48,9.48,0,0,1,6.48,11.72l-9.36,32.52a9.49,9.49,0,0,1-9.09,6.86Zm0-9.54-1.32,4.58,1.32-4.58Zm-38-46L2122.43,549l47.26,13.54,9.34-32.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2210.32,561.49a4.77,4.77,0,0,1-1.32-.19l-30.63-8.82a4.77,4.77,0,0,1,2.64-9.17l30.63,8.82a4.77,4.77,0,0,1-1.32,9.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2193.61,575.12a2,2,0,0,1-2-2.61l11.25-39.09a2,2,0,0,1,3.93,1.13l-11.25,39.09A2,2,0,0,1,2193.61,575.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2075.27,
    y: 680.95,
    width: 58.7,
    height: 43.25,
    rx: 3.45,
    ry: 3.45,
    transform: "translate(276.47 -554.77) rotate(16.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2136.71,697.21l-7.76,27a7.61,7.61,0,0,1-9.4,5.2l-21.3-6.13,12-41.57,21.3,6.13A7.61,7.61,0,0,1,2136.71,697.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2122.68,735.66a9.51,9.51,0,0,1-2.63-.37l-47.37-13.64a9.47,9.47,0,0,1-6.48-11.73l9.36-32.52a9.49,9.49,0,0,1,11.72-6.48l47.37,13.64a9.48,9.48,0,0,1,6.48,11.72l-9.36,32.52a9.49,9.49,0,0,1-9.09,6.86Zm0-9.54-1.32,4.58,1.32-4.58h0Zm-38-46-9.28,32.48,47.26,13.54,9.34-32.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2163.25,725a4.77,4.77,0,0,1-1.32-.19L2131.3,716a4.77,4.77,0,0,1,2.64-9.17l30.63,8.82a4.77,4.77,0,0,1-1.32,9.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2146.54,738.65a2,2,0,0,1-2-2.61l11.25-39.09a2,2,0,1,1,3.93,1.13l-11.25,39.09A2,2,0,0,1,2146.54,738.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2037.97,
    y: 825.9,
    width: 47.33,
    height: 37.19,
    rx: 8.45,
    ry: 8.45,
    transform: "translate(314.05 -537.34) rotate(16.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2071.37,870.94a16.35,16.35,0,0,1-4.53-.64l-23.36-6.72a16.3,16.3,0,0,1-11.14-20.14l3.92-13.62a16.28,16.28,0,0,1,20.15-11.14l23.36,6.72a16.28,16.28,0,0,1,11.14,20.15L2087,859.16a16.3,16.3,0,0,1-15.62,11.78Zm-19.47-43.37a6.75,6.75,0,0,0-6.47,4.88l-3.92,13.62a6.75,6.75,0,0,0,4.61,8.34l23.36,6.72a6.74,6.74,0,0,0,8.34-4.61l3.92-13.62a6.74,6.74,0,0,0-4.61-8.34l-23.36-6.72A6.78,6.78,0,0,0,2051.9,827.58Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2186.17,
    y: 459.69,
    width: 31.86,
    height: 379.19,
    rx: 7.93,
    ry: 7.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2220,468.56V832c0,4.35-7.13,7.88-15.93,7.88V460.68a26.22,26.22,0,0,1,11.27,2.3C2218.23,464.41,2220,466.38,2220,468.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2223.79,844.37h-41.4V455.19h41.4Zm-31.86-10h22.32V465.18h-22.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2177.9,
    y: 525.78,
    width: 53.1,
    height: 40.99,
    rx: 3.45,
    ry: 3.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2231,533v26.6a7.05,7.05,0,0,1-6.87,7.2h-20.05v-41h20.05A7.05,7.05,0,0,1,2231,533Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2225.6,572.5h-43.69a9.72,9.72,0,0,1-9.47-9.92V531.44a9.72,9.72,0,0,1,9.47-9.92h43.69a9.72,9.72,0,0,1,9.47,9.92v31.13A9.72,9.72,0,0,1,2225.6,572.5Zm0-10v0Zm-.07-31.07-43.63.07.07,31.07,43.56-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2259.84,552H2231a5,5,0,0,1,0-10h28.83a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2249.41,568.42a2.09,2.09,0,0,1-2-2.14V527.73a2,2,0,1,1,4.09,0v38.55A2.09,2.09,0,0,1,2249.41,568.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2177.9,
    y: 687.05,
    width: 53.1,
    height: 40.99,
    rx: 3.45,
    ry: 3.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2231,694.25v26.6a7.05,7.05,0,0,1-6.87,7.2h-20.05v-41h20.05A7.05,7.05,0,0,1,2231,694.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2225.6,733.77h-43.69a9.72,9.72,0,0,1-9.47-9.92V692.72a9.72,9.72,0,0,1,9.47-9.93h43.69a9.72,9.72,0,0,1,9.47,9.93v31.13A9.72,9.72,0,0,1,2225.6,733.77Zm0-10v0Zm-.07-31.07-43.63.07.07,31.07,43.56-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2259.84,713.28H2231a5,5,0,0,1,0-10h28.83a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2249.41,729.7a2.09,2.09,0,0,1-2-2.14V689a2,2,0,1,1,4.09,0v38.55A2.09,2.09,0,0,1,2249.41,729.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2181.19,
    y: 830.45,
    width: 42.81,
    height: 35.24,
    rx: 8.38,
    ry: 8.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2212.49,870.69H2192.7c-9,0-16.28-7.65-16.28-17.05V842.51c0-9.4,7.3-17.05,16.28-17.05h19.79c9,0,16.28,7.65,16.28,17.05v11.13C2228.77,863,2221.47,870.69,2212.49,870.69Zm-19.79-35.24a6.91,6.91,0,0,0-6.74,7.06v11.13a6.91,6.91,0,0,0,6.74,7.06h19.79a6.91,6.91,0,0,0,6.74-7.06V842.51a6.91,6.91,0,0,0-6.74-7.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2087.7,
    y: 368.75,
    width: 231.63,
    height: 58.59,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2318,389.19H2086.34a16.4,16.4,0,0,1,16.35-16.35h198.93A16.4,16.4,0,0,1,2318,389.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2275.84,432.79v24a11.48,11.48,0,0,1-11.45,11.45H2139.45A11.48,11.48,0,0,1,2128,456.77v-24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2128,363.3V308a11.48,11.48,0,0,1,11.45-11.45H2264.4A11.48,11.48,0,0,1,2275.84,308V363.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2276.64,309.34v55.32h-73.92V297.9h62.47A11.48,11.48,0,0,1,2276.64,309.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2202.72,434.15h73.92v24a11.48,11.48,0,0,1-11.45,11.45h-62.47Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2202.72,
    y1: 434.15,
    x2: 2202.72,
    y2: 364.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2139.47,250.89v8a11.75,11.75,0,0,0,11.75,11.75h96.4a11.75,11.75,0,0,0,11.75-11.75v-7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2259.38,252.66v7.6a11.36,11.36,0,0,1-.16,1.93l-119.64-.41a11.18,11.18,0,0,1-.1-1.53v-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2158.55,273.37v10.05a13.11,13.11,0,0,0,13.11,13.11h61a13.11,13.11,0,0,0,13.11-13.11V273.37"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2161.28,
    y: 276.1,
    width: 87.2,
    height: 8.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2061.81,
    y: 44.47,
    width: 283.41,
    height: 205.74,
    rx: 41.02,
    ry: 41.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2341.13,98.52v8.18a48.6,48.6,0,0,0-48.6-48.6H2106.32a48.6,48.6,0,0,0-48.6,48.6V98.52a48.6,48.6,0,0,1,48.6-48.6h186.21A48.6,48.6,0,0,1,2341.13,98.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2057.72,212.54V196.16c0,23.06,21.76,41.75,48.6,41.75h186.21c26.84,0,48.6-18.69,48.6-41.75v16.39c0,23.06-21.76,41.75-48.6,41.75H2106.32C2079.48,254.3,2057.72,235.6,2057.72,212.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2204.88,
    cy: 172.54,
    r: 65.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2247.63,280.19h-96.4a18.59,18.59,0,0,1-18.56-18.56v-8a6.81,6.81,0,1,1,13.63,0v8a4.94,4.94,0,0,0,4.94,4.94h96.4a4.94,4.94,0,0,0,4.94-4.94V254a6.81,6.81,0,1,1,13.63,0v7.6A18.59,18.59,0,0,1,2247.63,280.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2234,303.35h-61a20,20,0,0,1-19.92-19.92V273.37a6.81,6.81,0,1,1,13.63,0v10.05a6.31,6.31,0,0,0,6.3,6.3h61a6.31,6.31,0,0,0,6.3-6.3V273.37a6.81,6.81,0,1,1,13.63,0v10.05A20,20,0,0,1,2234,303.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2275.84,370.11a6.81,6.81,0,0,1-6.81-6.81V308a4.69,4.69,0,0,0-4.63-4.63H2139.45a4.7,4.7,0,0,0-4.63,4.63V363.3a6.81,6.81,0,1,1-13.63,0V308a18.28,18.28,0,0,1,18.26-18.26H2264.4A18.28,18.28,0,0,1,2282.65,308V363.3A6.81,6.81,0,0,1,2275.84,370.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2264.4,475H2139.45a18.28,18.28,0,0,1-18.26-18.26v-24a6.81,6.81,0,1,1,13.63,0v24a4.7,4.7,0,0,0,4.63,4.63H2264.4a4.69,4.69,0,0,0,4.63-4.63v-24a6.81,6.81,0,1,1,13.63,0v24A18.28,18.28,0,0,1,2264.4,475Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2301.39,435.52H2102.46a23.19,23.19,0,0,1-23.16-23.16V386.46a23.19,23.19,0,0,1,23.16-23.16h198.93a23.19,23.19,0,0,1,23.16,23.16v25.89A23.19,23.19,0,0,1,2301.39,435.52Zm-198.93-58.59a9.55,9.55,0,0,0-9.54,9.54v25.89a9.55,9.55,0,0,0,9.54,9.54h198.93a9.55,9.55,0,0,0,9.54-9.54V386.46a9.55,9.55,0,0,0-9.54-9.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 2204.88,
    cy: 153.47,
    r: 65.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2241.92,97l-80.57,102.89a65.25,65.25,0,0,1-13.79-13.33l78.13-99.76A64.58,64.58,0,0,1,2241.92,97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2260.17,122.38l-69.75,89.06a64.69,64.69,0,0,1-19.58-5.93l78.85-100.68A64.9,64.9,0,0,1,2260.17,122.38Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2204.88,225.68a72.21,72.21,0,1,1,72.21-72.21A72.3,72.3,0,0,1,2204.88,225.68Zm0-130.8a58.59,58.59,0,1,0,58.59,58.59A58.66,58.66,0,0,0,2204.88,94.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2204.88,224.32a70.85,70.85,0,1,1,70.85-70.85A70.93,70.93,0,0,1,2204.88,224.32Zm0-126.3a55.45,55.45,0,1,0,55.45,55.45A55.51,55.51,0,0,0,2204.88,98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2204.88,203.88a50.41,50.41,0,1,1,50.41-50.41A50.47,50.47,0,0,1,2204.88,203.88Zm0-92.65a42.24,42.24,0,1,0,42.24,42.24A42.29,42.29,0,0,0,2204.88,111.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2204.88,201.16a47.69,47.69,0,1,1,47.69-47.69A47.74,47.74,0,0,1,2204.88,201.16Zm0-87.2a39.51,39.51,0,1,0,39.51,39.51A39.56,39.56,0,0,0,2204.88,114Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 2300.25,
    cy: 86.7,
    r: 12.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2300.25,101a15.67,15.67,0,1,1,15.67-15.67A15.69,15.69,0,0,1,2300.25,101Zm0-24.53a8.86,8.86,0,1,0,8.86,8.86A8.87,8.87,0,0,0,2300.25,76.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2108,255a6.81,6.81,0,0,1-6.81-6.81v-201a6.81,6.81,0,1,1,13.63,0v201A6.81,6.81,0,0,1,2108,255Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2293.21,257.7H2107a55.47,55.47,0,0,1-55.41-55.41V93.74A55.47,55.47,0,0,1,2107,38.33h186.21a55.47,55.47,0,0,1,55.41,55.41V202.29A55.47,55.47,0,0,1,2293.21,257.7ZM2107,52a41.83,41.83,0,0,0-41.79,41.78V202.29A41.83,41.83,0,0,0,2107,244.08h186.21A41.83,41.83,0,0,0,2335,202.29V93.74A41.83,41.83,0,0,0,2293.21,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2110.73,253.62a4.09,4.09,0,0,1-4.09-4.09v-201a4.09,4.09,0,0,1,8.18,0v201A4.09,4.09,0,0,1,2110.73,253.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1664.13,165.84H1533.81a12.77,12.77,0,0,1-12.75-12.75V113a12.77,12.77,0,0,1,12.75-12.75h130.32A12.77,12.77,0,0,1,1676.88,113v40.12A12.77,12.77,0,0,1,1664.13,165.84Zm-130.32-55.62a2.76,2.76,0,0,0-2.75,2.75v40.12a2.76,2.76,0,0,0,2.75,2.75h130.32a2.76,2.76,0,0,0,2.75-2.75V113a2.76,2.76,0,0,0-2.75-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1718.25,222.22H1587.93a12.77,12.77,0,0,1-12.75-12.75V169.35a12.77,12.77,0,0,1,12.75-12.75h130.32A12.77,12.77,0,0,1,1731,169.35v40.12A12.77,12.77,0,0,1,1718.25,222.22Zm-130.32-55.62a2.76,2.76,0,0,0-2.75,2.75v40.12a2.76,2.76,0,0,0,2.75,2.75h130.32a2.76,2.76,0,0,0,2.75-2.75V169.35a2.76,2.76,0,0,0-2.75-2.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1579.13,739.84H1448.81a12.77,12.77,0,0,1-12.75-12.75V687a12.77,12.77,0,0,1,12.75-12.75h130.32A12.77,12.77,0,0,1,1591.88,687v40.12A12.77,12.77,0,0,1,1579.13,739.84Zm-130.32-55.62a2.76,2.76,0,0,0-2.75,2.75v40.12a2.76,2.76,0,0,0,2.75,2.75h130.32a2.76,2.76,0,0,0,2.75-2.75V687a2.76,2.76,0,0,0-2.75-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1633.25,796.22H1502.93a12.77,12.77,0,0,1-12.75-12.75V743.35a12.77,12.77,0,0,1,12.75-12.75h130.32A12.77,12.77,0,0,1,1646,743.35v40.12A12.77,12.77,0,0,1,1633.25,796.22Zm-130.32-55.62a2.76,2.76,0,0,0-2.75,2.75v40.12a2.76,2.76,0,0,0,2.75,2.75h130.32a2.76,2.76,0,0,0,2.75-2.75V743.35a2.76,2.76,0,0,0-2.75-2.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1152,849.22a5,5,0,0,1-1.06-9.89l69.52-15.11H1621a5,5,0,0,1,0,10H1221.54l-68.48,14.89A5,5,0,0,1,1152,849.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1589.77,853.22H1357c-13.91,0-26.9-7.65-36.57-21.54-9.28-13.33-14.49-31-14.68-49.84l-.71-70.56a5,5,0,0,1,4.95-5h.05a5,5,0,0,1,5,5l.71,70.56c.34,33.9,18.84,61.49,41.24,61.49H1584.5l212.88-310.33a5,5,0,0,1,8.25,5.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "880.77 725.41 880.77 914.22 1065.08 914.22 1065.08 732.16 880.77 725.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "880.77 740.02 880.77 781.61 1065.08 781.61 1065.08 741.51 880.77 740.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1070.08,919.22H875.77v-199l194.31,7.11v65.88a5,5,0,0,1-10,0V737L885.77,730.6V909.22h174.31V812.88a5,5,0,1,1,10,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M837.11,842.29h268.27a35,35,0,0,1,35,35v4.33a0,0,0,0,1,0,0H802.11a0,0,0,0,1,0,0v-4.33A35,35,0,0,1,837.11,842.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1147.63,887.75H799.35v-9.33a40,40,0,0,1,40-40h268.27a40,40,0,0,1,40,40Zm-338.26-10h328.26a30,30,0,0,0-30-29.33H839.35A30,30,0,0,0,809.36,877.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1490.12,102v624.2a22.8,22.8,0,0,1-22.8,22.8H500.8a22.76,22.76,0,0,1-22.8-22.8V102a22.75,22.75,0,0,1,2.25-9.89.07.07,0,0,1,0,0A22.83,22.83,0,0,1,496.8,79.57l.33-.05a22.17,22.17,0,0,1,3.67-.3h966.52a23.25,23.25,0,0,1,3.57.28h0A22.8,22.8,0,0,1,1490.12,102Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 504.57,
    y: 114.05,
    width: 959.84,
    height: 601.24,
    rx: 7.33,
    ry: 7.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 506.98,
    y: 114.05,
    width: 959.84,
    height: 601.24,
    rx: 7.33,
    ry: 7.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 503.88,
    y: 114.05,
    width: 963.88,
    height: 16.48,
    rx: 7.33,
    ry: 7.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 503.88,
    y: 698.44,
    width: 963.88,
    height: 16.48,
    rx: 7.33,
    ry: 7.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1474.43,118.29c-.11-8.08-3.7-15.58-9.57-19.8a40.35,40.35,0,0,0-8.1-4.47,17.56,17.56,0,0,0-6.67-1.31H514.68a19.46,19.46,0,0,0-12.33,4.35l-.2.16c-5.64,4.66-9,12.26-9.21,20.35l-.34,12.09L479.17,614V719.18a28.28,28.28,0,0,0,5,16.3c.17.25.34.48.53.72,4,5.11,9.74,8.33,16.12,8.33h968.41a19.52,19.52,0,0,0,11.91-4.14,4,4,0,0,0,1.43-3.19Zm-6.65,3.58v577c0,6.61-4.57,12-10.21,12h-945a6.54,6.54,0,0,1-5.17-2.67,2.54,2.54,0,0,1-.25-.33,8.9,8.9,0,0,1-1.83-5.52V121.36a5.11,5.11,0,0,0-.17-1.2,9.47,9.47,0,0,1-.3-2.36A8.92,8.92,0,0,1,506.9,112a6.57,6.57,0,0,1,2-1.62,6.1,6.1,0,0,1,3.46-1.08h945.8a3,3,0,0,1,2.55,1.75l.15.3A3.18,3.18,0,0,0,1463,113c2.88.53,3.82,3,3.82,7C1466.79,121.53,1468.38,120.67,1467.78,121.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1456.86,720H511.69a12.35,12.35,0,0,1-12.33-12.33V121.11a12.35,12.35,0,0,1,12.33-12.33h945.17a12.35,12.35,0,0,1,12.33,12.33V707.68A12.35,12.35,0,0,1,1456.86,720ZM511.69,118.77a2.34,2.34,0,0,0-2.33,2.33V707.68a2.34,2.34,0,0,0,2.33,2.33h945.17a2.34,2.34,0,0,0,2.33-2.33V121.11a2.34,2.34,0,0,0-2.33-2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1470.89,754.29H497.66c-13.48,0-24.44-12.47-24.44-27.8V102.3c0-15.33,11-27.8,24.44-27.8H639.79a5,5,0,0,1,0,10H497.66c-8,0-14.44,8-14.44,17.8v624.2c0,9.82,6.48,17.8,14.44,17.8h973.23c8,0,14.44-8,14.44-17.8V102.3c0-9.82-6.48-17.8-14.44-17.8H766.57a5,5,0,0,1,0-10h704.31c13.48,0,24.44,12.47,24.44,27.8v624.2C1495.33,741.82,1484.37,754.29,1470.89,754.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M748.95,84.5H728.48a5,5,0,0,1,0-10h20.47a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M706.31,84.5H660.25a5,5,0,0,1,0-10h46.05a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1586.65,
    y: 262.22,
    width: 358,
    height: 604,
    rx: 37.88,
    ry: 37.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1948,820.22v17.89c0,15-17,27.11-37.88,27.11H1627.88c-20.92,0-37.88-12.14-37.88-27.11V820.22c0,15,17,27.11,37.88,27.11h282.24C1931,847.32,1948,835.19,1948,820.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1586.65,308.22V290.32c0-15,17-27.11,37.88-27.11h282.24c20.92,0,37.88,12.14,37.88,27.11v17.89c0-15-17-27.11-37.88-27.11H1624.53C1603.61,281.11,1586.65,293.24,1586.65,308.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 5,
    y: 881.22,
    width: 2414,
    height: 51,
    rx: 25.5,
    ry: 25.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2419,901.72a26.72,26.72,0,0,1-6.81,18,22.22,22.22,0,0,1-16.44,7.47H28.26C15.41,927.22,5,915.8,5,901.72a27.54,27.54,0,0,1,1.5-9c3.31,9.64,11.81,16.5,21.76,16.5H2395.74a22.22,22.22,0,0,0,16.44-7.47,25.88,25.88,0,0,0,5.32-9A27.54,27.54,0,0,1,2419,901.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2393.5,935.22H30.5a30.5,30.5,0,0,1,0-61h2363a30.5,30.5,0,0,1,0,61Zm-2363-51a20.5,20.5,0,0,0,0,41h2363a20.5,20.5,0,0,0,0-41Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1648.45,
    cy: 318.97,
    r: 11.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1648.45,332.25A14.55,14.55,0,1,1,1663,317.7,14.56,14.56,0,0,1,1648.45,332.25Zm0-22.77a8.22,8.22,0,1,0,8.22,8.22A8.23,8.23,0,0,0,1648.45,309.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1906.77,871.72H1624.52a42.93,42.93,0,0,1-42.88-42.88V300.59a42.93,42.93,0,0,1,42.88-42.88H1686a5,5,0,0,1,0,10h-61.48a32.92,32.92,0,0,0-32.88,32.88V828.84a32.91,32.91,0,0,0,32.88,32.88h282.25a32.91,32.91,0,0,0,32.88-32.88V300.59a32.92,32.92,0,0,0-32.88-32.88H1862a5,5,0,0,1,0-10h44.77a42.93,42.93,0,0,1,42.88,42.88V828.84A42.93,42.93,0,0,1,1906.77,871.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1832,267.72h-22a5,5,0,0,1,0-10h22a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1786,267.72h-67a5,5,0,0,1,0-10h67a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M604.63,510.79,569,636.12a15.21,15.21,0,0,1-18.8,10.48L507,634.32l-1.67-.48-.74-.21-.22-.06-25.18-7.16-1-.27-.21-.06V615.57l-18.37-5.22a18.74,18.74,0,0,1-8.94,8L428,611.88a18.79,18.79,0,0,1-3.41-11.48l-28.23-8,1.35-4.75h0l1.35-4.74,14.11-49.64,3.12-11L422.64,500v0l.29-1L426,488l11.52-40.53,27.71,7.88L470,456.7l4.74,1.35L478,459l.21.06,5.22,1.49,2.72.77,5.69,1.62,1.9.54,2.84.8,4.75,1.35,3,.86.22.06.74.21,1.67.48,82.08,23.33,4.76,1.35.32.09a15.23,15.23,0,0,1,10.49,18.81Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.7,769.84H237.38a12.77,12.77,0,0,1-12.75-12.75V717a12.77,12.77,0,0,1,12.75-12.75H367.7A12.77,12.77,0,0,1,380.45,717v40.12A12.77,12.77,0,0,1,367.7,769.84ZM237.38,714.22a2.76,2.76,0,0,0-2.75,2.75v40.12a2.76,2.76,0,0,0,2.75,2.75H367.7a2.76,2.76,0,0,0,2.75-2.75V717a2.76,2.76,0,0,0-2.75-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M421.82,826.22H291.5a12.77,12.77,0,0,1-12.75-12.75V773.35a12.77,12.77,0,0,1,12.75-12.75H421.82a12.77,12.77,0,0,1,12.75,12.75v40.12A12.77,12.77,0,0,1,421.82,826.22ZM291.5,770.59a2.76,2.76,0,0,0-2.75,2.75v40.12a2.76,2.76,0,0,0,2.75,2.75H421.82a2.76,2.76,0,0,0,2.75-2.75V773.35a2.76,2.76,0,0,0-2.75-2.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.7,306.84H111.38a12.77,12.77,0,0,1-12.75-12.75V254a12.77,12.77,0,0,1,12.75-12.75H241.7A12.77,12.77,0,0,1,254.45,254v40.12A12.77,12.77,0,0,1,241.7,306.84ZM111.38,251.22a2.76,2.76,0,0,0-2.75,2.75v40.12a2.76,2.76,0,0,0,2.75,2.75H241.7a2.76,2.76,0,0,0,2.75-2.75V254a2.76,2.76,0,0,0-2.75-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.82,363.22H165.5a12.77,12.77,0,0,1-12.75-12.75V310.35a12.77,12.77,0,0,1,12.75-12.75H295.82a12.77,12.77,0,0,1,12.75,12.75v40.12A12.77,12.77,0,0,1,295.82,363.22ZM165.5,307.59a2.76,2.76,0,0,0-2.75,2.75v40.12a2.76,2.76,0,0,0,2.75,2.75H295.82a2.76,2.76,0,0,0,2.75-2.75V310.35a2.76,2.76,0,0,0-2.75-2.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M544.82,80.84H414.5a12.77,12.77,0,0,1-12.75-12.75V28A12.77,12.77,0,0,1,414.5,15.22H544.82A12.77,12.77,0,0,1,557.57,28V68.09A12.77,12.77,0,0,1,544.82,80.84ZM414.5,25.22A2.76,2.76,0,0,0,411.75,28V68.09a2.76,2.76,0,0,0,2.75,2.75H544.82a2.76,2.76,0,0,0,2.75-2.75V28a2.76,2.76,0,0,0-2.75-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M490.7,137.22H360.38a12.77,12.77,0,0,1-12.75-12.75V84.35a12.77,12.77,0,0,1,12.75-12.75H490.7a12.77,12.77,0,0,1,12.75,12.75v40.12A12.77,12.77,0,0,1,490.7,137.22ZM360.38,81.59a2.76,2.76,0,0,0-2.75,2.75v40.12a2.76,2.76,0,0,0,2.75,2.75H490.7a2.76,2.76,0,0,0,2.75-2.75V84.35a2.76,2.76,0,0,0-2.75-2.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M48.84,372H72.51a0,0,0,0,1,0,0v66.55A7.41,7.41,0,0,1,65.1,446H56.25a7.41,7.41,0,0,1-7.41-7.41V372a0,0,0,0,1,0,0Z",
    transform: "translate(470.69 462.47) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M94.23,429.82l-59.76-17a11.83,11.83,0,0,1-8.15-14.62l71.14,20.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.53,397.14A16.78,16.78,0,0,1,43.24,385.6l64.5,18.33-9.17,32.25-64.5-18.33A16.78,16.78,0,0,1,22.53,397.14Zm73,13.58-55-15.64a6.9,6.9,0,1,0-3.77,13.28l55,15.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.79,311.44a20.11,20.11,0,0,1,3.61-7,19.5,19.5,0,0,1,20.95-6.76l128.71,36.58a19.81,19.81,0,0,1,4.76,36.05l-56.11,33.62a4.93,4.93,0,0,1-5.07-8.46l56.11-33.62a9.95,9.95,0,0,0-2.39-18.1L256.65,307.18a9.95,9.95,0,0,0-11.41,14.41l32.44,58.21a4.93,4.93,0,1,1-8.61,4.8l-32.44-58.21A19.54,19.54,0,0,1,234.79,311.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.78,582.39a19.53,19.53,0,0,1,9.43-11.75l58.21-32.44a4.93,4.93,0,0,1,4.8,8.61L172,579.25a9.95,9.95,0,0,0,2.12,18.26l128.71,36.58A9.95,9.95,0,0,0,314.4,620l-30-58.1a4.93,4.93,0,0,1,8.76-4.53l30,58.1a19.81,19.81,0,0,1-23,28.16L171.44,607a19.5,19.5,0,0,1-14.26-16.77A20.11,20.11,0,0,1,157.78,582.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284,558.14a4.93,4.93,0,0,1,3.54-3.44l152.27-38.34L330.48,403.67a4.93,4.93,0,1,1,7.08-6.87l121.23,125L290,564.26a4.93,4.93,0,0,1-5.95-6.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.44,420.75l168.83-42.51a4.93,4.93,0,0,1,2.41,9.56L122.41,426.15,231.75,538.84a4.93,4.93,0,0,1-7.08,6.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.51,712.18,345.89,225.31a4.93,4.93,0,1,1,9.49,2.7L217,714.87a4.93,4.93,0,1,1-9.49-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M379.91,582.56l-250-71.06a46,46,0,0,1-4.58-1.56q-1.12-.44-2.2-.93a47.86,47.86,0,0,1-5.18-2.77c-.66-.4-1.31-.83-2-1.27l-.94-.67A47.49,47.49,0,0,1,109,499q-.8-.83-1.55-1.67c-.75-.86-1.48-1.73-2.16-2.63s-1.34-1.84-2-2.78a47.16,47.16,0,0,1-5.94-38.85l18.1-63.67c.11-.39.23-.78.35-1.17.06-.21.13-.41.2-.62s.17-.53.26-.78c.31-.9.64-1.79,1-2.66q.25-.61.53-1.2c.16-.38.34-.75.51-1.11.56-1.17,1.16-2.32,1.81-3.42.2-.33.4-.68.6-1s.23-.39.36-.57.39-.6.58-.89.46-.68.7-1,.54-.76.82-1.13q1.19-1.57,2.49-3c.32-.37.65-.72,1-1.06l.81-.83c.3-.31.62-.61.94-.91l.94-.86,1-.85c.62-.53,1.27-1,1.92-1.55l.1-.07c.67-.51,1.36-1,2.05-1.48.37-.25.74-.5,1.12-.73l1.09-.67c.36-.23.74-.44,1.11-.65l1.13-.62c.39-.21.76-.4,1.15-.59l1.16-.55c.39-.19.78-.35,1.18-.53a47,47,0,0,1,31.55-2l250,71.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 51.77,
    y: 413.2,
    width: 101.43,
    height: 14.79,
    rx: 7.4,
    ry: 7.4,
    transform: "translate(-330.1 404.19) rotate(-74.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85.2,468.41a7.35,7.35,0,0,1-1.95-.87,7.4,7.4,0,0,0,7-5.38L114,378.82a7.37,7.37,0,0,0-.65-5.62,7.47,7.47,0,0,0-2.49-2.64A7.4,7.4,0,0,1,118,380L94.34,463.31A7.4,7.4,0,0,1,85.2,468.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.21,459.3,103.9,376a10.85,10.85,0,1,1,20.87,5.93l-23.69,83.34a10.85,10.85,0,0,1-20.87-5.93ZM118.13,380a3.94,3.94,0,1,0-7.59-2.16L86.85,461.19a3.94,3.94,0,0,0,7.59,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M185,531.36a5.43,5.43,0,0,0,1.32.87,5.47,5.47,0,0,1,.56-6.51l42.52-47.84a5.45,5.45,0,0,1,3.76-1.83,5.52,5.52,0,0,1,2.63.5,5.47,5.47,0,0,0-8.73-.75l-42.52,47.84A5.46,5.46,0,0,0,185,531.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M163.23,525.15a5.43,5.43,0,0,0,1.32.87,5.47,5.47,0,0,1,.56-6.51l42.52-47.84a5.45,5.45,0,0,1,3.76-1.83,5.52,5.52,0,0,1,2.63.5,5.47,5.47,0,0,0-8.73-.75l-42.52,47.84A5.46,5.46,0,0,0,163.23,525.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.41,519a5.43,5.43,0,0,0,1.32.87,5.47,5.47,0,0,1,.56-6.51l42.52-47.84a5.45,5.45,0,0,1,3.76-1.83,5.52,5.52,0,0,1,2.63.5,5.47,5.47,0,0,0-8.73-.75L141,511.24A5.46,5.46,0,0,0,141.41,519Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M252.39,550.5a5.43,5.43,0,0,0,1.32.87,5.47,5.47,0,0,1,.56-6.51L296.79,497a5.45,5.45,0,0,1,3.76-1.83,5.52,5.52,0,0,1,2.63.5,5.47,5.47,0,0,0-8.73-.75l-42.52,47.84A5.46,5.46,0,0,0,252.39,550.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M230.58,544.3a5.43,5.43,0,0,0,1.32.87,5.47,5.47,0,0,1,.56-6.51L275,490.81a5.45,5.45,0,0,1,3.76-1.83,5.52,5.52,0,0,1,2.63.5,5.47,5.47,0,0,0-8.73-.75l-42.52,47.84A5.46,5.46,0,0,0,230.58,544.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M208.76,538.1a5.43,5.43,0,0,0,1.32.87,5.47,5.47,0,0,1,.56-6.51l42.52-47.84a5.45,5.45,0,0,1,3.76-1.83,5.52,5.52,0,0,1,2.63.5,5.47,5.47,0,0,0-8.73-.75L208.3,530.38A5.46,5.46,0,0,0,208.76,538.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M298.49,384.7a5.43,5.43,0,0,1,1.58,0,5.47,5.47,0,0,0-2.94,5.83l11,63.05a5.45,5.45,0,0,0,2.24,3.53,5.52,5.52,0,0,0,2.5,1,5.47,5.47,0,0,1-7.82-4l-11-63.05A5.46,5.46,0,0,1,298.49,384.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M276.68,378.5a5.43,5.43,0,0,1,1.58,0,5.47,5.47,0,0,0-2.94,5.83l11,63.05a5.45,5.45,0,0,0,2.24,3.53,5.52,5.52,0,0,0,2.5,1,5.47,5.47,0,0,1-7.82-4l-11-63.05A5.46,5.46,0,0,1,276.68,378.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M254.86,372.29a5.43,5.43,0,0,1,1.58,0,5.47,5.47,0,0,0-2.94,5.83l11,63.05a5.45,5.45,0,0,0,2.24,3.53,5.52,5.52,0,0,0,2.5,1,5.47,5.47,0,0,1-7.82-4l-11-63.05A5.46,5.46,0,0,1,254.86,372.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M539.34,627.87l-156.57-44.5,43.95-154.62,156.57,44.5a15.22,15.22,0,0,1,10.48,18.81L558.14,617.39A15.22,15.22,0,0,1,539.34,627.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M540.28,628.14l-156.57-44.5L427.66,429l7.37,2.09L416.71,533a45.35,45.35,0,0,0,29.4,50.75L556.32,623A15.23,15.23,0,0,1,540.28,628.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M341.5,569.82a16.15,16.15,0,0,1-3.66-1.54c5.87.19,11.09-3,12.53-8l37.18-130.81a10.74,10.74,0,0,0-1.64-9,14.66,14.66,0,0,0-4.8-4.4,16.14,16.14,0,0,1,3.93.62,15.22,15.22,0,0,1,8.46,5.94,10.74,10.74,0,0,1,1.64,9L358,562.43C356.2,568.59,348.83,571.9,341.5,569.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M231.28,368.67a5.43,5.43,0,0,1,1.58,0,5.47,5.47,0,0,0-2.94,5.83l11,63.05a5.45,5.45,0,0,0,2.24,3.53,5.52,5.52,0,0,0,2.5,1,5.47,5.47,0,0,1-7.82-4l-11-63.05A5.46,5.46,0,0,1,231.28,368.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M209.47,362.47a5.43,5.43,0,0,1,1.58,0,5.47,5.47,0,0,0-2.94,5.83l11,63.05a5.45,5.45,0,0,0,2.24,3.53,5.52,5.52,0,0,0,2.5,1,5.47,5.47,0,0,1-7.82-4l-11-63.05A5.46,5.46,0,0,1,209.47,362.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M187.65,356.27a5.43,5.43,0,0,1,1.58,0,5.47,5.47,0,0,0-2.94,5.83l11,63.05a5.45,5.45,0,0,0,2.24,3.53,5.52,5.52,0,0,0,2.5,1,5.47,5.47,0,0,1-7.82-4l-11-63.05A5.46,5.46,0,0,1,187.65,356.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M382.76,583.37l-250-71.06a47.27,47.27,0,0,1-32.55-58.4l18.1-63.67a47.16,47.16,0,0,1,26.85-30.53,47.09,47.09,0,0,0-9.33,17.57l-18.1,63.67a47.27,47.27,0,0,0,32.55,58.4l237.21,67.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.14,397.73l-.57,2,1,.27Zm-32.46-9.92-1.85.47-1.64.41-1.84.46,2,.58,1.81.51,2.16.62-.54-3.08ZM265,545.86l.76-.86-.48-.13Zm-33.69-10.65-1.71-.49L227,534l1.69,1.75,1.13,1.16,1.46,1.51.42.43a3.17,3.17,0,0,1,.3.34,4.92,4.92,0,0,1,.41-.52l2.22-2.5-1.08-.31Zm353.28-66.7L507,446.44l-.7-.2-1-.27-.74-.21-.22-.07-3-.85L498.5,444l-2.34-.67-5.25-1.49-6.91-2-2.62-.75-3.17-.9-.21-.06-1.81-.51-4.93-1.4-39-11.08-4.23-1.2-.71-.2-2.84-.81-2.34-.67-5.25-1.49-9.52-2.71s0,0,0,0l-5.19-1.47-4.93-1.4-53.88-15.32h0l-3.83-1.09-8.62-2.45-.33-.09h0l-17.19-4.89-3.16-.9-1-.27-.28-.08-1.91-.55-1.42-.4-3.67-1-2.21-.63-.63-.18L297.7,387l-1.41-.4-.81-.24h0l-4-1.14-3.15-.9-1.25-.35-1.92-.55-1.42-.4-3.66-1-1.8-.51-.1,0h0l-.94-.27-1.31-.37-1.54-.44-.68-.2h0l-4.16-1.18-3.16-.9-1.09-.31-.16,0-1.91-.55-1.43-.4-3.66-1-2.84-.81-1.18-.33-1.68-.48h0l-.54-.15-6.21-1.76-3.22-.92-1.36-.39h0l-4.28-1.21-3.18-.91-3.17-.9-6.74-1.91-3.2-.91h0l-1.36-.39-4.3-1.23s0,0,0,0l-3.17-.9-3.16-.9-6.74-1.91-3.22-.92-1.36-.39h0l-.54-.15-3.74-1.06-3.18-.91-3.17-.9-8.45-2.4a51.69,51.69,0,0,0-20.25-1.64,52.44,52.44,0,0,0-35.55,20.22c-.72.93-1.4,1.89-2.06,2.88s-1.3,2.05-1.9,3.12c-.06.1-.12.2-.17.3a51.87,51.87,0,0,0-4.57,11.07l-9,31.57-.32,1.13-8.8,31a52.14,52.14,0,0,0-2,12.43v.21c0,1.3,0,2.6,0,3.89s.15,2.37.28,3.55a52.28,52.28,0,0,0,37.6,44.42l8.5,2.42,3.2.91,2.86.81,4.42,1.26h0l1.39.39h0l3.22.92,6.85,1.95,3.19.9,2.87.82,4.41,1.26s0,0,0,0l1.4.39L177,530l6.86,1.95,3.19.91,2.87.81,4.41,1.26h0l1.39.39h0l3.22.92,8.33,2.37,3.2.91,2.86.81,4.43,1.26,1,.29.35.11,2.67.75.56.16,6.85,2,2.48.7.14.05h0l.56.16,2.86.81,4.43,1.26,1.39.39h0l3.22.92,6.86,1.95,2,.56,1.23.35,2.86.81,4.43,1.26,1,.28.42.12,3.23.91,17.6,5h.06l10,2.85h0l2.59.74h0l54,15.37,4.94,1.4,5.18,1.47,9.54,2.71,5.23,1.49s0,0,0,0l2.35.67,2.84.81.66.19h0l.11,0,4.12,1.17,10.74,3.06,28.23,8,4.94,1.4,5.18,1.47,9.54,2.71,5.23,1.49,2.36.67,2.84.81,4.93,1.4L478,615.57l.21.06,1,.27,25.18,7.16.22.06.74.21,1.67.48,31,8.81a20.19,20.19,0,0,0,24.91-13.88l35.48-124.82.14-.51A20.18,20.18,0,0,0,584.63,468.51ZM589,490.72,553.4,616a10.23,10.23,0,0,1-3.06,4.88,10.34,10.34,0,0,1-9.66,2.21L507,613.55l-1.67-.47-.74-.21-.22-.06-25-7.09-1.19-.34-.21-.06L462.84,601l-4.74-1.35-2.85-.81-1.9-.54-5.69-1.62-11.38-3.23-4.74-1.35-4.75-1.35-27.71-7.88L388.85,580l-3.79-1.08-1-.27-2.85-.81-1.89-.54h0l-5.69-1.62-11.38-3.23-4.74-1.35-4.75-1.35-1.3-.37-7.59-2.16-30.8-8.76h0l-19-5.39h0l-20.58-5.84-3.16-.9-1.25-.36-1.91-.54L265.8,545l-.48-.13-3.44-1-3.17-.9-2.22-.63-.66-.19-.27-.08-2.39-.68-1.58-.45-3.16-.89-1.24-.36-1.92-.54-1.43-.41-3.91-1.11-3.17-.9h0l-2.07-.59-1.08-.31-2.25-.64-1.71-.49L227,534h0l-.56-.16-1.25-.36-1.91-.54-1.43-.41L218,531.41l-3.17-.9-1.94-.55-1.21-.35-2.12-.6-1.47-.42-1.86-.53-3.16-.9-1.26-.35-1.9-.54-1.43-.41-3.92-1.12-3.16-.89h0l-2.21-.63h0l-.93-.27-2.39-.68-1.58-.45-3.16-.9-1.25-.35-1.91-.54-1.42-.41-3.92-1.11h0l-3.16-.9h0l-2.06-.59h0l-1.08-.31-2.26-.64-1.7-.49-3.16-.9-1.26-.35-1.9-.54-1.42-.41-3.93-1.12-3.16-.89h0l-1.93-.56-1.22-.34-2.12-.61h0l-8.07-2.29a42.4,42.4,0,0,1-29.16-52.31l7.25-25.48h0l3.43-12.08,7.42-26.1a42.1,42.1,0,0,1,16.12-22.86,0,0,0,0,0,0,0,42.29,42.29,0,0,1,36.18-6.28l8.23,2.34,2,.57,1.32.38,1.85.52,3.15.9,3.93,1.12,1.43.4,1.91.55,1.24.35,3.17.9,1.8.51,2.16.62,1.18.33,2,.56,3.16.9,3.93,1.12,1.42.4,1.92.55,1.24.35,3.16.9,1.67.47,2.29.65,1,.3,2.12.6,3.15.9,3.93,1.12,1.43.4,1.9.54h0l1.24.36,3.17.9,2.85.81,1,.28,2,.58,1.32.37,1.84.53,3.16.89,3.92,1.12,1.43.41,1.91.54,1.25.35,1.13.32h0l2,.58,1.81.51,2.16.62,1.18.33,2,.57,3.17.9,3.92,1.11,1.42.4,1.92.55,1.25.35,3.15.9,1.68.48,2.08.59.21.06,1,.3h0l2.11.6,3.16.89,3,.85,1,.27,1.42.41,1.91.54,1.25.35,3.16.9,19,5.41,19,5.4h0l33.76,9.59,7,2,.59.17h0l4.14,1.18,4.74,1.35,11.39,3.23,5.68,1.62h0l1.89.54h0l2.84.81,1,.27,3.79,1.08h0l4,1.15,33.9,9.63,4.74,1.35,4.74,1.35.47.13.21.06,5.51,1.56,5.2,1.48,5.69,1.62,1.9.54,2.84.81,4.75,1.35.25.07.22.06.74.21,1.67.48L581.93,478a10.29,10.29,0,0,1,7.13,12.54A1.17,1.17,0,0,1,589,490.72ZM233.6,535.85l-2.25-.64-1.71-.49L227,534h0l1.7,1.75,1.13,1.16,1.46,1.51.42.43a3.17,3.17,0,0,1,.3.34,4.92,4.92,0,0,1,.41-.52l2.22-2.5Zm31.72,9-.28,1,.76-.86Zm9.48-157.09-.12,0-1.85.47-1.64.41-1.84.46,2,.58,1.81.51,2.16.62Zm32.34,9.95-.57,2,1,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M378,582,422,427.4a4.93,4.93,0,1,1,9.49,2.7L387.5,584.72A4.93,4.93,0,1,1,378,582Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 296.78,
    y: 488.48,
    width: 189.34,
    height: 27.61,
    rx: 13.81,
    ry: 13.81,
    transform: "translate(-198.72 741.5) rotate(-74.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M362.73,592.54a13.72,13.72,0,0,1-3.64-1.63,13.82,13.82,0,0,0,13.1-10l44.22-155.57a13.76,13.76,0,0,0-1.22-10.5,13.94,13.94,0,0,0-4.65-4.93A13.81,13.81,0,0,1,424,427.47L379.78,583A13.81,13.81,0,0,1,362.73,592.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.32,574.95l44.22-155.57a18.74,18.74,0,1,1,36,10.25L387.37,585.19a18.74,18.74,0,0,1-36-10.25Zm70.78-148A8.88,8.88,0,0,0,405,422.07L360.81,577.64a8.88,8.88,0,0,0,17.07,4.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 175.99,
    y: 501.75,
    width: 74.93,
    height: 10.93,
    rx: 5.46,
    ry: 5.46,
    transform: "translate(-307.47 329.82) rotate(-48.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M237.47,478.43a5.43,5.43,0,0,0-1.32-.87,5.47,5.47,0,0,1-.56,6.51l-42.52,47.84a5.45,5.45,0,0,1-3.76,1.83,5.52,5.52,0,0,1-2.63-.5,5.47,5.47,0,0,0,8.73.75l42.52-47.84A5.46,5.46,0,0,0,237.47,478.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.1,528.82a8.37,8.37,0,0,1,1.8-3.28l42.52-47.84A8.42,8.42,0,1,1,241,488.89l-42.52,47.84a8.42,8.42,0,0,1-14.39-7.91Zm53-44.84a2.51,2.51,0,0,0-4.28-2.35l-42.52,47.84a2.51,2.51,0,1,0,3.75,3.33L236.59,485A2.5,2.5,0,0,0,237.12,484Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 154.03,
    y: 495.51,
    width: 74.93,
    height: 10.93,
    rx: 5.46,
    ry: 5.46,
    transform: "translate(-310.18 311.32) rotate(-48.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M215.51,472.19a5.43,5.43,0,0,0-1.32-.87,5.47,5.47,0,0,1-.56,6.51l-42.52,47.84a5.45,5.45,0,0,1-3.76,1.83,5.52,5.52,0,0,1-2.63-.5,5.47,5.47,0,0,0,8.73.75L216,479.91A5.46,5.46,0,0,0,215.51,472.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.14,522.58a8.37,8.37,0,0,1,1.8-3.28l42.52-47.84a8.42,8.42,0,1,1,12.59,11.19l-42.52,47.84a8.42,8.42,0,0,1-14.39-7.91Zm53-44.84a2.51,2.51,0,0,0-4.28-2.35l-42.52,47.84a2.51,2.51,0,1,0,3.75,3.33l42.52-47.84A2.5,2.5,0,0,0,215.17,477.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 132.08,
    y: 489.27,
    width: 74.93,
    height: 10.93,
    rx: 5.46,
    ry: 5.46,
    transform: "translate(-312.88 292.81) rotate(-48.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M193.56,466a5.43,5.43,0,0,0-1.32-.87,5.47,5.47,0,0,1-.56,6.51l-42.52,47.84a5.45,5.45,0,0,1-3.76,1.83,5.52,5.52,0,0,1-2.63-.5,5.47,5.47,0,0,0,8.73.75L194,473.67A5.46,5.46,0,0,0,193.56,466Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.18,516.35a8.39,8.39,0,0,1,1.81-3.29l42.52-47.84a8.42,8.42,0,1,1,12.59,11.19l-42.52,47.84a8.43,8.43,0,0,1-14.4-7.9Zm53-44.85a2.51,2.51,0,0,0-4.28-2.35L146.41,517a2.51,2.51,0,1,0,3.75,3.33l42.52-47.84A2.5,2.5,0,0,0,193.21,471.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 243.34,
    y: 520.9,
    width: 74.93,
    height: 10.93,
    rx: 5.46,
    ry: 5.46,
    transform: "translate(-299.17 386.59) rotate(-48.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M304.82,497.58a5.43,5.43,0,0,0-1.32-.87,5.47,5.47,0,0,1-.56,6.51l-42.52,47.84a5.45,5.45,0,0,1-3.76,1.83,5.52,5.52,0,0,1-2.63-.5,5.47,5.47,0,0,0,8.73.75l42.52-47.84A5.46,5.46,0,0,0,304.82,497.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.45,548a8.37,8.37,0,0,1,1.8-3.28l42.52-47.84A8.42,8.42,0,1,1,308.36,508l-42.52,47.84A8.42,8.42,0,0,1,251.45,548Zm53-44.84a2.51,2.51,0,0,0-4.28-2.35l-42.52,47.84a2.51,2.51,0,1,0,3.75,3.33l42.52-47.84A2.5,2.5,0,0,0,304.47,503.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 221.38,
    y: 514.65,
    width: 74.93,
    height: 10.93,
    rx: 5.46,
    ry: 5.46,
    transform: "translate(-301.88 368.08) rotate(-48.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M282.86,491.34a5.43,5.43,0,0,0-1.32-.87A5.47,5.47,0,0,1,281,497l-42.52,47.84a5.45,5.45,0,0,1-3.76,1.83,5.52,5.52,0,0,1-2.63-.5,5.47,5.47,0,0,0,8.73.75L283.32,499A5.46,5.46,0,0,0,282.86,491.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.49,541.72a8.37,8.37,0,0,1,1.8-3.28l42.52-47.84a8.42,8.42,0,1,1,12.59,11.19l-42.52,47.84a8.42,8.42,0,0,1-14.39-7.91Zm53-44.84a2.51,2.51,0,0,0-4.28-2.35l-42.52,47.84a2.51,2.51,0,1,0,3.75,3.33L282,497.86A2.5,2.5,0,0,0,282.52,496.88Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 199.43,
    y: 508.41,
    width: 74.93,
    height: 10.93,
    rx: 5.46,
    ry: 5.46,
    transform: "translate(-304.58 349.58) rotate(-48.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M260.91,485.1a5.43,5.43,0,0,0-1.32-.87,5.47,5.47,0,0,1-.56,6.51l-42.52,47.84a5.45,5.45,0,0,1-3.76,1.83,5.52,5.52,0,0,1-2.63-.5,5.47,5.47,0,0,0,8.73.75l42.52-47.84A5.46,5.46,0,0,0,260.91,485.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.53,535.49a8.39,8.39,0,0,1,1.81-3.29l42.52-47.84a8.42,8.42,0,1,1,12.59,11.19l-42.52,47.84a8.43,8.43,0,0,1-14.4-7.9Zm53-44.85a2.51,2.51,0,0,0-4.28-2.35l-42.52,47.84a2.51,2.51,0,1,0,3.75,3.33L260,491.62A2.5,2.5,0,0,0,260.56,490.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 237.23,
    y: 366.88,
    width: 10.93,
    height: 74.93,
    rx: 5.46,
    ry: 5.46,
    transform: "translate(-65.88 47.73) rotate(-9.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M248,441.46a5.43,5.43,0,0,1-1.58,0,5.47,5.47,0,0,0,2.94-5.83l-11-63.05a5.45,5.45,0,0,0-2.24-3.53,5.52,5.52,0,0,0-2.5-1,5.47,5.47,0,0,1,7.82,4l11,63.05A5.46,5.46,0,0,1,248,441.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.08,370.52a8.43,8.43,0,0,1,16.41.85l11,63.05a8.42,8.42,0,0,1-6.85,9.74h0a8.42,8.42,0,0,1-9.74-6.85l-11-63.05A8.39,8.39,0,0,1,229.08,370.52Zm21.52,66a2.49,2.49,0,0,0,.06-1.11l-11-63.05a2.51,2.51,0,0,0-4.94.86l11,63.05a2.5,2.5,0,0,0,2.9,2h0a2.49,2.49,0,0,0,1.62-1A2.51,2.51,0,0,0,250.6,436.56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 215.27,
    y: 360.64,
    width: 10.93,
    height: 74.93,
    rx: 5.46,
    ry: 5.46,
    transform: "translate(-65.13 43.86) rotate(-9.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M226,435.22a5.43,5.43,0,0,1-1.58,0,5.47,5.47,0,0,0,2.94-5.83l-11-63.05a5.45,5.45,0,0,0-2.24-3.53,5.52,5.52,0,0,0-2.5-1,5.47,5.47,0,0,1,7.82,4l11,63.05A5.46,5.46,0,0,1,226,435.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.13,364.28a8.43,8.43,0,0,1,16.41.85l11,63.05a8.42,8.42,0,0,1-6.85,9.74h0a8.42,8.42,0,0,1-9.74-6.85l-11-63.05A8.39,8.39,0,0,1,207.13,364.28Zm21.52,66a2.49,2.49,0,0,0,.06-1.11l-11-63.05a2.51,2.51,0,0,0-4.94.86l11,63.05a2.5,2.5,0,0,0,2.9,2h0a2.49,2.49,0,0,0,1.62-1A2.51,2.51,0,0,0,228.65,430.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 193.32,
    y: 354.4,
    width: 10.93,
    height: 74.93,
    rx: 5.46,
    ry: 5.46,
    transform: "translate(-64.39 39.99) rotate(-9.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M204.07,429a5.43,5.43,0,0,1-1.58,0,5.47,5.47,0,0,0,2.94-5.83l-11-63.05a5.45,5.45,0,0,0-2.24-3.53,5.52,5.52,0,0,0-2.5-1,5.47,5.47,0,0,1,7.82,4l11,63.05A5.46,5.46,0,0,1,204.07,429Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.17,358a8.43,8.43,0,0,1,16.4.85l11,63.05a8.42,8.42,0,0,1-6.85,9.74h0a8.42,8.42,0,0,1-9.74-6.85l-11-63.05A8.39,8.39,0,0,1,185.17,358Zm21.52,66a2.49,2.49,0,0,0,.06-1.11l-11-63.05a2.51,2.51,0,0,0-4.94.86l11,63.05a2.5,2.5,0,0,0,2.9,2h0a2.49,2.49,0,0,0,1.62-1A2.51,2.51,0,0,0,206.69,424.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 304.44,
    y: 382.91,
    width: 10.93,
    height: 74.93,
    rx: 5.46,
    ry: 5.46,
    transform: "translate(-67.63 59.51) rotate(-9.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M315.19,457.48a5.43,5.43,0,0,1-1.58,0,5.47,5.47,0,0,0,2.94-5.83l-11-63.05a5.45,5.45,0,0,0-2.24-3.53,5.52,5.52,0,0,0-2.5-1,5.47,5.47,0,0,1,7.82,4l11,63.05A5.46,5.46,0,0,1,315.19,457.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.29,386.55a8.43,8.43,0,0,1,16.41.85l11,63.05a8.42,8.42,0,0,1-6.85,9.74h0a8.42,8.42,0,0,1-9.74-6.85l-11-63.05A8.39,8.39,0,0,1,296.29,386.55Zm21.52,66a2.49,2.49,0,0,0,.06-1.11l-11-63.05a2.51,2.51,0,0,0-4.94.86l11,63.05a2.5,2.5,0,0,0,2.9,2h0a2.49,2.49,0,0,0,1.62-1A2.51,2.51,0,0,0,317.81,452.58Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 282.48,
    y: 376.67,
    width: 10.93,
    height: 74.93,
    rx: 5.46,
    ry: 5.46,
    transform: "translate(-66.89 55.65) rotate(-9.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M293.23,451.24a5.43,5.43,0,0,1-1.58,0,5.47,5.47,0,0,0,2.94-5.83l-11-63.05a5.45,5.45,0,0,0-2.24-3.53,5.52,5.52,0,0,0-2.5-1,5.47,5.47,0,0,1,7.82,4l11,63.05A5.46,5.46,0,0,1,293.23,451.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.34,380.31a8.43,8.43,0,0,1,16.41.85l11,63.05a8.42,8.42,0,0,1-6.85,9.74h0a8.42,8.42,0,0,1-9.74-6.85l-11-63.05A8.39,8.39,0,0,1,274.34,380.31Zm21.52,66a2.49,2.49,0,0,0,.06-1.11l-11-63.05A2.51,2.51,0,0,0,280,383l11,63.05a2.5,2.5,0,0,0,2.9,2h0a2.49,2.49,0,0,0,1.62-1A2.51,2.51,0,0,0,295.86,446.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 260.53,
    y: 370.43,
    width: 10.93,
    height: 74.93,
    rx: 5.46,
    ry: 5.46,
    transform: "translate(-66.14 51.78) rotate(-9.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M271.28,445a5.43,5.43,0,0,1-1.58,0,5.47,5.47,0,0,0,2.94-5.83l-11-63.05a5.45,5.45,0,0,0-2.24-3.53,5.52,5.52,0,0,0-2.5-1,5.47,5.47,0,0,1,7.82,4l11,63.05A5.46,5.46,0,0,1,271.28,445Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.38,374.07a8.43,8.43,0,0,1,16.4.85l11,63.05a8.42,8.42,0,0,1-6.85,9.74h0a8.42,8.42,0,0,1-9.74-6.85l-11-63.05A8.39,8.39,0,0,1,252.38,374.07Zm21.52,66A2.49,2.49,0,0,0,274,439l-11-63.05a2.51,2.51,0,0,0-4.94.86l11,63.05a2.5,2.5,0,0,0,2.9,2h0a2.49,2.49,0,0,0,1.62-1A2.51,2.51,0,0,0,273.9,440.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 370.77,
    y: 509.51,
    width: 189.34,
    height: 27.61,
    rx: 13.81,
    ry: 13.81,
    transform: "translate(-165.18 827.95) rotate(-74.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M436.72,613.57a13.72,13.72,0,0,1-3.64-1.63,13.82,13.82,0,0,0,13.1-10L490.4,446.34a13.76,13.76,0,0,0-1.22-10.5,13.94,13.94,0,0,0-4.65-4.93A13.81,13.81,0,0,1,498,448.49L453.77,604.06A13.81,13.81,0,0,1,436.72,613.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M478,511.61l-21.55,75.82,1.86.67L478,518.83l.21-.74v-7.22Zm-27,12.12-15.51,54.55a41.12,41.12,0,0,0,4.37,2.67l16.65-58.61Zm54.33-84.14a17.69,17.69,0,0,0-.74-1.87l-.22-.46a18.7,18.7,0,0,0-26.14-7.95l-.21.12a18.72,18.72,0,0,0-6.74,6.86,18.39,18.39,0,0,0-1.73,4.12l-.13.47L468,445.63l-2.77,9.73-16.07,56.53-3.76,13.23L431.28,575l-4.49,15.78-1.34,4.74-.14.48a18.7,18.7,0,0,0,2.71,15.9,18.75,18.75,0,0,0,31.61-1.53,19.15,19.15,0,0,0,1.73-4.13l.13-.47,1.35-4.74,2.92-10.26L478,547.68l.21-.73,3.12-11,20-70.35,2.77-9.72.25-.88.22-.77.74-2.61.14-.49.13-.47a18.62,18.62,0,0,0-.27-11.07ZM434.8,598.68l.14-.48,1.34-4.74,3.56-12.51,16.65-58.61.65-2.28,17.62-62,2.77-9.72.47-1.65.21-.74.67-2.36.13-.47a8.88,8.88,0,0,1,10.71-6.17,2.44,2.44,0,0,1,.26.06,8.87,8.87,0,0,1,6.11,11l-.13.47-1.35,4.75-2.77,9.73L482.44,496l-4.23,14.9-.21.74-21.55,75.82-3.1,10.88L452,603l-.14.48a8.56,8.56,0,0,1-2.37,3.94,8.82,8.82,0,0,1-8.59,2.17l-.25-.08a8.87,8.87,0,0,1-5.86-10.88Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 559.68,
    y: 494.33,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1200.79 86.9) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 553.81,
    y: 515.01,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1213.2 118.89) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 547.93,
    y: 535.69,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1225.6 150.87) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 542.05,
    y: 556.37,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "matrix(-0.27, 0.96, -0.96, -0.27, 1238.01, 182.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 536.17,
    y: 577.05,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1250.42 214.85) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 530.3,
    y: 597.73,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1262.83 246.83) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 551.66,
    y: 492.05,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1188.39 91.71) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 545.79,
    y: 512.73,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1200.79 123.7) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 539.91,
    y: 533.41,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1213.2 155.69) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 534.03,
    y: 554.09,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1225.61 187.67) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 528.15,
    y: 574.77,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "matrix(-0.27, 0.96, -0.96, -0.27, 1238.01, 219.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 522.28,
    y: 595.45,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1250.42 251.64) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 543.65,
    y: 489.77,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1175.98 96.52) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 537.77,
    y: 510.45,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1188.39 128.51) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 531.89,
    y: 531.13,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1200.8 160.5) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 526.01,
    y: 551.81,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "matrix(-0.27, 0.96, -0.96, -0.27, 1213.2, 192.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 520.14,
    y: 572.49,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1225.61 224.47) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 514.26,
    y: 593.17,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1238.02 256.46) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 535.63,
    y: 487.49,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1163.58 101.33) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 529.75,
    y: 508.17,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1175.98 133.32) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 523.87,
    y: 528.85,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1188.39 165.31) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 517.99,
    y: 549.53,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1200.8 197.29) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 512.12,
    y: 570.21,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1213.21 229.28) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 506.24,
    y: 590.89,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1225.61 261.27) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 527.61,
    y: 485.22,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1151.17 106.15) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 521.73,
    y: 505.89,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1163.58 138.13) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 515.85,
    y: 526.57,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1175.99 170.12) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 509.97,
    y: 547.25,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1188.39 202.11) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 504.1,
    y: 567.93,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1200.8 234.09) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 498.22,
    y: 588.61,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1213.21 266.08) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 519.59,
    y: 482.94,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1138.77 110.96) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 513.71,
    y: 503.62,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1151.18 142.94) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 507.83,
    y: 524.29,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "matrix(-0.27, 0.96, -0.96, -0.27, 1163.58, 174.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 501.95,
    y: 544.97,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1175.99 206.92) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 496.08,
    y: 565.65,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1188.4 238.9) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 490.2,
    y: 586.33,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1200.8 270.89) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 511.57,
    y: 480.66,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1126.36 115.77) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 505.69,
    y: 501.34,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1138.77 147.76) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 499.81,
    y: 522.02,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1151.18 179.74) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 493.93,
    y: 542.69,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "matrix(-0.27, 0.96, -0.96, -0.27, 1163.59, 211.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 488.06,
    y: 563.37,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1175.99 243.72) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 482.18,
    y: 584.05,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1188.4 275.7) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 503.55,
    y: 478.38,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1113.96 120.58) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 497.67,
    y: 499.06,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1126.37 152.57) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 491.79,
    y: 519.74,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1138.77 184.55) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 485.92,
    y: 540.42,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1151.18 216.54) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 480.04,
    y: 561.09,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1163.59 248.53) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 474.16,
    y: 581.77,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1175.99 280.51) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 495.53,
    y: 476.1,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1101.56 125.39) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 489.65,
    y: 496.78,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1113.96 157.38) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 483.77,
    y: 517.46,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1126.37 189.37) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 477.9,
    y: 538.14,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "matrix(-0.27, 0.96, -0.96, -0.27, 1138.78, 221.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 472.02,
    y: 558.82,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1151.18 253.34) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 466.14,
    y: 579.49,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1163.59 285.32) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 447.75,
    y: 462.52,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1027.65 154.06) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 441.87,
    y: 483.2,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1040.06 186.04) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 436,
    y: 503.88,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1052.47 218.03) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 430.12,
    y: 524.56,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1064.87 250.02) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 424.24,
    y: 545.24,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1077.28 282) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 418.36,
    y: 565.91,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1089.69 313.99) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 439.73,
    y: 460.24,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "matrix(-0.27, 0.96, -0.96, -0.27, 1015.25, 158.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 433.85,
    y: 480.92,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1027.65 190.86) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 427.98,
    y: 501.6,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1040.06 222.84) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 422.1,
    y: 522.28,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1052.47 254.83) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 416.22,
    y: 542.96,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1064.88 286.82) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 410.34,
    y: 563.64,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1077.28 318.8) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 431.71,
    y: 457.96,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1002.84 163.68) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 425.83,
    y: 478.64,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "matrix(-0.27, 0.96, -0.96, -0.27, 1015.25, 195.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 419.96,
    y: 499.32,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "matrix(-0.27, 0.96, -0.96, -0.27, 1027.66, 227.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 414.08,
    y: 520,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1040.06 259.64) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 408.2,
    y: 540.68,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1052.47 291.63) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 402.32,
    y: 561.36,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1064.88 323.61) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 423.69,
    y: 455.68,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(990.44 168.49) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 417.81,
    y: 476.36,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1002.85 200.48) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 411.94,
    y: 497.04,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1015.25 232.47) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 406.06,
    y: 517.72,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1027.66 264.45) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 400.18,
    y: 538.4,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1040.07 296.44) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 394.3,
    y: 559.08,
    width: 15.78,
    height: 5.29,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(1052.47 328.43) rotate(105.87)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 336.51,
    cy: 486.38,
    r: 15.78,
    transform: "translate(-223.34 677.1) rotate(-74.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.52,481a20.71,20.71,0,1,1,14.26,25.58A20.73,20.73,0,0,1,316.52,481Zm30.35,8.63a10.85,10.85,0,1,0-13.4,7.47A10.86,10.86,0,0,0,346.87,489.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32.07 399.22 23.07 399.22 23.07 91.08 3.39 71.4 9.75 65.03 32.07 87.35 32.07 399.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1943.5,814.55h-354a5,5,0,0,1,0-10h354a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1944,820.22H1590a5,5,0,0,1,0-10h354a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M627.79,483.81l15-139.93A128.89,128.89,0,0,0,660.21,342a154.8,154.8,0,0,1,16.26-2.07q0,.2-.59,4T674.3,354q-1,6.21-2.17,14t-3.45,21.38q-2.27,13.6-6,37.64h3q5.12-18.13,8.47-29.66t5.42-18.72q2.07-7.19,3.94-13.89T687,352.35q1.67-5.71,2.66-9.66h1.77a66.41,66.41,0,0,0,7.19-.39q3.64-.39,6.9-.89t6.8-1.28a70.17,70.17,0,0,0-.89,7.29q-.49,5.52-1.28,13.3t-1.58,17.15q-.79,9.36-1.58,18.33t-1.48,17q-.69,8.08-1.28,13.8h3.55l18.72-84.75q6.7-1,13.2-1.77,5.71-.79,11.83-1.58t10.84-1.77q-3,8.28-5.91,18.43T750.38,377q-3.15,11.23-6,22.67t-5.62,22.07q-6.31,25.23-12.22,51.83L682,481,690.66,405h-2.37l-19.51,71.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M739.73,483.22l25.82-140.13,62.28-5.32q-1.38,4.34-2.37,8.87-1,3.75-1.87,7.79t-1.48,7.19q-2,.2-5.62.3l-7.79.2q-4.14.1-8.38.1h-7.39L786,397.48q6.11-.39,11.43-.59,4.33-.19,8.87-.2t6.7-.2q-.79,5.52-1.48,10.84t-1.68,10.84q-2,.2-6.41.3t-9,.3q-5.13.2-11.23.39l-6.7,36.26,28.78-4.53-2,22.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M846.85,477.11q-6.8.4-13.7,1.18t-13.5,2.07a95.39,95.39,0,0,0-11.92,3.05q1.18-8.87,2.76-19.71t3.65-22.47q2.07-11.63,4.14-23.45t4.24-22.67q4.92-25.82,10.45-52.62L867.45,338q-5.32,22.87-10.25,44.54-2.17,9.27-4.34,19.22t-4.14,19.41q-2,9.46-3.55,18.33t-2.56,15.77q4.92-.39,10.54-.49t10-.1q.19,3.75.59,7.39t.89,6.6q.49,3,.79,5.22t.49,3.05c-1.05,0-2.07,0-3.05-.1s-2-.1-3.06-.1Q853.65,476.71,846.85,477.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M932.39,459.47a76.26,76.26,0,0,1-12.22,13.4,46.53,46.53,0,0,1-12.91,8,34.31,34.31,0,0,1-12.61,2.56,22.73,22.73,0,0,1-11.14-2.76,25.48,25.48,0,0,1-8.77-8.28,46.29,46.29,0,0,1-6-13.6,70.38,70.38,0,0,1-2.27-18.92,133.06,133.06,0,0,1,5.12-36.56A120.06,120.06,0,0,1,886,370.87a80.79,80.79,0,0,1,22-23.16A48.39,48.39,0,0,1,936,338.95a21.7,21.7,0,0,1,9.07,2,22.25,22.25,0,0,1,7.49,5.52,26.74,26.74,0,0,1,5,8.67,33.16,33.16,0,0,1,1.87,11.43V369a19.12,19.12,0,0,1-.2,2.66l-25.82,6.9q-2.37-4.92-5.52-4.93t-6.6,3.65a50.38,50.38,0,0,0-6.8,9.46,132.53,132.53,0,0,0-6.5,13q-3.15,7.2-5.52,14.49t-3.84,13.89a51.47,51.47,0,0,0-1.48,10.74q0,6.31,1.67,8.87a5.08,5.08,0,0,0,4.43,2.56,9.77,9.77,0,0,0,4.93-1.68,22.46,22.46,0,0,0,5.12-4.34,38,38,0,0,0,4.34-6,24.18,24.18,0,0,0,2.76-6.7l22.47,9.07A99.54,99.54,0,0,1,932.39,459.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1045.32,406.84a132.35,132.35,0,0,1-9.16,26.21,107.33,107.33,0,0,1-13.3,21.29,104.17,104.17,0,0,1-15.87,16,68.19,68.19,0,0,1-16.75,10.05,42.86,42.86,0,0,1-16.16,3.45,27.78,27.78,0,0,1-11.83-2.46,25.92,25.92,0,0,1-9.26-7.29,35.38,35.38,0,0,1-6.21-12.42,64.18,64.18,0,0,1-2.27-18.23,105.57,105.57,0,0,1,2.76-23.26,166,166,0,0,1,7.49-24.24A133.52,133.52,0,0,1,966.38,373a115.25,115.25,0,0,1,15.18-19.22,71.3,71.3,0,0,1,17.74-13.3A42.15,42.15,0,0,1,1019,335.6q8.87,0,14.68,3.65a26.09,26.09,0,0,1,9.07,9.46,43.09,43.09,0,0,1,4.63,13.11,78.5,78.5,0,0,1,1.38,14.58A129.55,129.55,0,0,1,1045.32,406.84Zm-70.66,36a13.7,13.7,0,0,0,2.17,4.14,12.89,12.89,0,0,0,3.45,3.05,8.26,8.26,0,0,0,4.43,1.28,23.1,23.1,0,0,0,15.77-6.11,50.4,50.4,0,0,0,11.43-15,87,87,0,0,0,7-18.92,77.64,77.64,0,0,0,2.46-18.33,48.38,48.38,0,0,0-.3-5.12,20.88,20.88,0,0,0-1.18-5.12,10.12,10.12,0,0,0-2.76-4,7.27,7.27,0,0,0-5-1.68,22.41,22.41,0,0,0-11.63,3.15,35.87,35.87,0,0,0-9.56,8.38,59,59,0,0,0-7.39,11.83,116.34,116.34,0,0,0-5.42,13.4,79.74,79.74,0,0,0-3.25,13.3,76.21,76.21,0,0,0-1,11.23A14.29,14.29,0,0,0,974.66,442.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1028.27,481.84q8.67-26.21,16.56-51.44,3.35-10.64,6.9-22.27t7.1-23.06q3.55-11.43,6.6-22.07t5.42-19.71a168.87,168.87,0,0,0,20.5-1.18q9.65-1.18,20.89-2.17-.59,4.34-1.28,9.76T1109.37,361q-.89,5.91-1.87,12.22t-2.36,16.16q-1.38,9.86-3.74,24.64H1104q5.71-15,9.46-24.93t6.11-16.26q2.37-6.31,4.83-12.32t4.73-11.43q2.26-5.42,4.24-9.56,4.92-.39,9.26-1t8.67-1.28l8.77-1.38q4.43-.69,9.76-1.68-2,11.43-3.74,23.45t-3.15,23.95q-1.38,11.93-2.66,23.55T1158,427.24q-2.37,24.44-4.14,47.7L1119.52,481q0-1,.3-5.32t.79-10.64q.49-6.31,1.38-14l1.77-15.37q.89-7.69,1.87-14.88t2-12.32h-1.77q-2.76,8.28-6.11,17.44t-6.8,18.63q-3.45,9.46-6.8,18.53t-5.91,17.34q-6.9.2-11.83.49l-11.43.69,6.31-73.12h-3q-.4,2.56-2,8.57t-3.65,13.8q-2.07,7.79-4.43,16.16t-4.43,15.57q-2.07,7.2-3.45,11.83t-1.58,5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1157.75,483.22l25.82-140.13,62.28-5.32q-1.38,4.34-2.37,8.87-1,3.75-1.87,7.79t-1.48,7.19q-2,.2-5.62.3l-7.79.2q-4.14.1-8.38.1H1211l-6.9,35.28q6.11-.39,11.43-.59,4.33-.19,8.87-.2t6.7-.2q-.79,5.52-1.48,10.84t-1.68,10.84q-2,.2-6.41.3t-9,.3q-5.13.2-11.23.39l-6.7,36.26,28.78-4.53-2,22.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1266.45,474.74a19.72,19.72,0,0,1-4.83,6.6,23.08,23.08,0,0,1-7.88,4.53,32.44,32.44,0,0,1-10.84,1.68,17.39,17.39,0,0,1-7.49-1.58,14.61,14.61,0,0,1-5.42-4.24,21.18,21.18,0,0,1-3.25-6,20,20,0,0,1-1.18-6.7,22,22,0,0,1,1.18-7.19,17,17,0,0,1,3.65-6.11,20.31,20.31,0,0,1,6.11-4.43,19.88,19.88,0,0,1,8.77-1.77q11.43,0,17.15,5.42t5.72,12.32A18.23,18.23,0,0,1,1266.45,474.74Zm-11.73-38-11.43.79q6.11-24.24,11.92-48.29t12.12-48.29q3.74-.59,8.57-1.18t9.76-1.38q4.92-.79,9.56-1.38t7.79-1.18q-10.64,24.83-19.41,50t-17.44,50.55Q1260.43,436.31,1254.72,436.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1375,
    y: 150.85,
    width: 45,
    height: 38.45,
    rx: 7.58,
    ry: 7.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1375,
    y: 207.31,
    width: 45,
    height: 38.45,
    rx: 7.58,
    ry: 7.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1375,
    y: 263.76,
    width: 45,
    height: 38.45,
    rx: 7.58,
    ry: 7.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 131,
    y: 833.22,
    width: 672,
    height: 35,
    rx: 7,
    ry: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 130,
    y: 833.22,
    width: 672,
    height: 20,
    rx: 7,
    ry: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M798,877.22H140a12,12,0,0,1-12-12v-21a12,12,0,0,1,12-12H543.5a5,5,0,0,1,0,10H140a2,2,0,0,0-2,2v21a2,2,0,0,0,2,2H798a2,2,0,0,0,2-2v-21a2,2,0,0,0-2-2H571.5a5,5,0,0,1,0-10H798a12,12,0,0,1,12,12v21A12,12,0,0,1,798,877.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1116.5,820.22h38a28.5,28.5,0,0,1,28.5,28.5v6.21a17.29,17.29,0,0,1-17.29,17.29h-60.43A17.29,17.29,0,0,1,1088,854.93v-6.21A28.5,28.5,0,0,1,1116.5,820.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1182,847.72v6.21a17.29,17.29,0,0,1-17.29,17.29h-60.42A17.29,17.29,0,0,1,1087,853.93v-6.21a27.53,27.53,0,0,1,.34-4.38,17.29,17.29,0,0,0,16.95,13.88h60.42a17.29,17.29,0,0,0,16.95-13.88A27.53,27.53,0,0,1,1182,847.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1165.71,878.22h-60.43A22.31,22.31,0,0,1,1083,855.93v-6.21a33.54,33.54,0,0,1,33.5-33.5h38a33.54,33.54,0,0,1,33.5,33.5v6.21A22.31,22.31,0,0,1,1165.71,878.22Zm-49.21-52a23.53,23.53,0,0,0-23.5,23.5v6.21a12.3,12.3,0,0,0,12.29,12.29h60.43A12.3,12.3,0,0,0,1178,855.93v-6.21a23.53,23.53,0,0,0-23.5-23.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1655,
    y: 767.22,
    width: 217,
    height: 13,
    rx: 6.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1856.24,524.47H1675a16.92,16.92,0,0,1-16.9-16.9v-41.2a16.92,16.92,0,0,1,16.9-16.9h181.19a16.92,16.92,0,0,1,16.9,16.9v41.2A16.92,16.92,0,0,1,1856.24,524.47Zm-181.19-65a6.91,6.91,0,0,0-6.9,6.9v41.2a6.91,6.91,0,0,0,6.9,6.9h181.19a6.91,6.91,0,0,0,6.9-6.9v-41.2a6.91,6.91,0,0,0-6.9-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1843.15,492h-154a5,5,0,0,1,0-10h154a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1856.24,630.47H1675a16.92,16.92,0,0,1-16.9-16.9v-41.2a16.92,16.92,0,0,1,16.9-16.9h181.19a16.92,16.92,0,0,1,16.9,16.9v41.2A16.92,16.92,0,0,1,1856.24,630.47Zm-181.19-65a6.91,6.91,0,0,0-6.9,6.9v41.2a6.91,6.91,0,0,0,6.9,6.9h181.19a6.91,6.91,0,0,0,6.9-6.9v-41.2a6.91,6.91,0,0,0-6.9-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1843.15,598h-154a5,5,0,0,1,0-10h154a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 1641.9,
    y: 380.22,
    width: 252,
    height: 388,
    rx: 25.79,
    ry: 25.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1890.8,756.62a25.79,25.79,0,0,1-23.69,15.6H1666.69a25.79,25.79,0,0,1-25.79-25.79V410a25.79,25.79,0,0,1,15.6-23.69,25.65,25.65,0,0,0-2.1,10.19V732.93a25.79,25.79,0,0,0,25.79,25.79h200.42A25.65,25.65,0,0,0,1890.8,756.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1759.42,379.22l-70.74,388h-28a25.73,25.73,0,0,1-22.14-12.58L1707,379.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1848.09 379.22 1777.35 767.22 1703.25 767.22 1774 379.22 1848.09 379.22"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1863.61,773.22H1663.19a30.83,30.83,0,0,1-30.79-30.79V406a30.83,30.83,0,0,1,30.79-30.79h200.42A30.83,30.83,0,0,1,1894.4,406V742.43A30.83,30.83,0,0,1,1863.61,773.22Zm-200.42-388A20.81,20.81,0,0,0,1642.4,406V742.43a20.81,20.81,0,0,0,20.79,20.79h200.42a20.81,20.81,0,0,0,20.79-20.79V406a20.81,20.81,0,0,0-20.79-20.79Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeMedia);
export default __webpack_public_path__ + "static/media/youtube-media.00df8bad6274029e424f137767b216c0.svg";
export { ForwardRef as ReactComponent };